import React from "react";
import PropTypes from "prop-types";

// import router link
import { Link } from "react-router-dom";

// import moment
import moment from "moment";
import "moment/locale/fr";
import SocialShare from "../../common/SocialShare";
// import flag
import Flag from "react-flagkit";

// import constants
import { ITEMS_TO_DISPLAY_XS, USER_DATA } from "../../../helpers/constants";

// import utilities
import {
  calculateCol,
  formatArrayToString,
  slugify,
} from "../../../helpers/utilities";

// import custom common components
import Lister from "../../common/Lister";

// import custom icons
import {
  icDate,
  icDeliveryMode,
  icLanguage,
  icPlaceholder,
} from "../../../assets/images";

// import logo

import logo1 from "../../../assets/images/logo.png";
import premium from "../../../assets/fonts/premium.svg";

const ListSchool = ({
  items,
  itemsPerRow,
  isPublic,
  partenary,
  listerClasses,
  withDiscover,
  withPagination,
  favourites,
  opened,
  onClosed,
  handleModel
}) => {
  return (
    <React.Fragment>
      <Lister
        listerClasses={`${listerClasses} schools`}
        withDiscover={withDiscover}
        withPagination={withPagination}
        discoverOptions={{ discoverLink: "/etablissements" }}
      >
        {items &&
          items.length > 0 &&
          items.map((item, index) => {
            try {
              let school = {
                ...item,
                logo: item.logo ? item.logo : icPlaceholder,
                country: item.country_name ? item.country_name : "",
                language: item.language ? JSON.parse(item.language) : null,
                formationRhythm: item.formationRhythm
                  ? JSON.parse(item.formationRhythm)
                  : null,
                teachingMode: item.teachingMode
                  ? JSON.parse(item.teachingMode)
                  : null,
                annualBackToSchool: item.annualBackToSchool
                  ? item.annualBackToSchool
                  : "",
                recognizedByState: item.recognizedByState
                  ? item.recognizedByState
                  : false,
                isPublic: item.isPublic ? item.isPublic : 0,
                note: item.note ? item.note : 0,
                publicId: item.publicId ? item.publicId : "",
                slug: item.slug ? item.slug : "",
                name: item.name ? item.name : "",
                city: item.city ? item.city : "",
                sector: item.sector ? item.sector : {},
                level: item.level ? item.level : {},
                countryflag: item.flag
                  ? `https://digital4design.ca/ace-api/src/${item.flag}`
                  : "",
              };
              // console.log("your school", school.country);
              // const isPrivateSchool= partenary && item.partenary != 0;
              const isPrivateSchool = !partenary && item.partenary === 0;
              const showOverlay = item.isPublic !== 1;
              // console.log("isPrivateSchool", isPrivateSchool);
              return (
                <React.Fragment key={`school_item_${index}`}>
                  {isPrivateSchool && showOverlay ? (
                    <div className="relative w-full">
                      <SchoolItem {...school} favourites={favourites} opened={opened} onClosed={onClosed} handleModel={handleModel} />
                      <div className='w-full absolute top-0 left-0 z-10 flex items-center space-x-3 p-3'>
                        {item?.flag ? (<img src={item.flag} alt={item.country_name} className='w-10 h-6' />
                        ) : (
                          <Flag
                            className="ms-1 border border-dark"
                            height={16}
                            width={22}
                          />
                        )}
                        <p className='text-[#505050] text-lg font-semibold'>{item.country_name}</p>
                      </div>
                      <div className="w-full absolute flex flex-1 justify-center items-center top-0 left-0 h-full flex-col backdrop-filter backdrop-blur-md bg-opacity-30 rounded-lg">
                        <div className='w-full flex space-x-2 justify-center items-center'>
                          <img src={premium} alt="premium" className="w-8" />
                          <p className="text-[#005073] text-lg font-semibold">Accessible aux abonnés</p>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <SchoolItem {...school} favourites={favourites} opened={opened} onClosed={onClosed} handleModel={handleModel} />
                  )}
                </React.Fragment>
              );
            } catch (error) {
              console.error("Error parsing JSON:", error);
              return null; // Skip this item if there was an error parsing JSON
            }
          })}
      </Lister>
    </React.Fragment>
  );
};

ListSchool.propTypes = {
  items: PropTypes.array,
  itemsPerRow: PropTypes.number,
  listerClasses: PropTypes.string,
  withPagination: PropTypes.bool,
  isPublic: PropTypes.bool,
  partenary: PropTypes.bool,
};

ListSchool.defaultProps = {
  itemsPerRow: ITEMS_TO_DISPLAY_XS,
  listerClasses: "g-3 mt-5",
  withDiscover: false,
  withPagination: false,
  isPublic: false,
};

export default ListSchool;

/**
 * School Item.
 */
const SchoolItem = ({
  recognizedByState,
  logo,
  name,
  publicId,
  isPublic,
  country,
  annualBackToSchool,
  teachingMode,
  city,
  language,
  note,
  countryflag,
  favourites,
  opened,
  onClosed,
  handleModel
}) => (
  <>
    <div className="grow ace_school_card flex-col relative rounded-lg">
      <div className="flex w-full items-start p-4">
        <img src={logo1} alt="Logo" />
        <div className="ml-4 grow">
          <p>{name}</p>
          <div className="flex items-center">
            <div className="flex">
              {Array.from(Array(5), (_, index) => (
                <svg
                  key={index}
                  width="17"
                  height="17"
                  viewBox="0 0 17 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9.19344 0.505972L11.0807 4.33001C11.2122 4.59816 11.4684 4.78261 11.7639 4.82702L15.9824 5.44016C16.7271 5.54776 17.0243 6.46321 16.4846 6.98754L13.4308 9.96274C13.2173 10.1711 13.12 10.4717 13.1695 10.7655L13.8902 14.967C14.0166 15.7082 13.2395 16.2735 12.5734 15.9234L8.79891 13.9388C8.53418 13.8004 8.21821 13.8004 7.9552 13.9388L4.18069 15.9234C3.5146 16.2735 2.73749 15.7082 2.86388 14.967L3.58462 10.7655C3.63586 10.4717 3.5368 10.1711 3.32331 9.96274L0.274666 6.98583C-0.26333 6.4615 0.0338489 5.54605 0.776795 5.43845L4.99536 4.82531C5.29084 4.78261 5.54702 4.59645 5.67853 4.3283L7.56579 0.505972C7.89883 -0.168657 8.86039 -0.168657 9.19173 0.505972H9.19344Z"
                    fill="#F2C94C"
                  />
                </svg>
              ))}
            </div>
            <span className="mx-2">|</span>
            <p className="text-[12px]">
              {city && (city + ",")}
              <strong> {country ? country : ""}</strong>
            </p>
            {country.countryCode && country.countryCode !== "" ? (
              <Flag
                country={country.countryCode.toUpperCase()}
                className="ms-1 border border-dark"
                height={16}
                width={22}
              />
            ) : (
              <span style={{ marginLeft: '5px' }}><img src={countryflag} alt="flag" height={16} width={22} /></span>
            )}
          </div>

          <div className="flex items-center">
            {recognizedByState ? (
              <>
                <svg
                  width="19"
                  height="18"
                  viewBox="0 0 19 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.94 9C17.94 9.83094 16.4773 10.4227 16.2308 11.1728C15.9753 11.9498 16.7975 13.2771 16.3217 13.9239C15.8458 14.5707 14.3069 14.2114 13.646 14.6863C12.985 15.1613 12.8726 16.7154 12.0867 16.9669C11.328 17.2106 10.3093 16.0271 9.46888 16.0271C8.62847 16.0271 7.60861 17.2106 6.85111 16.9669C6.0652 16.7143 5.94596 15.1568 5.29179 14.6863C4.63082 14.2114 3.09763 14.5763 2.6161 13.9239C2.13456 13.2715 2.96248 11.9498 2.70695 11.1728C2.45142 10.3958 1 9.83094 1 9C1 8.16906 2.46278 7.57729 2.70922 6.8272C2.96475 6.05015 2.14251 4.72289 2.61837 4.0761C3.09422 3.42931 4.63309 3.78864 5.29407 3.31365C5.95504 2.83867 6.06634 1.2857 6.85224 1.03305C7.61089 0.789384 8.62961 1.97292 9.47002 1.97292C10.3104 1.97292 11.3303 0.790507 12.0878 1.03305C12.8737 1.2857 12.9929 2.84316 13.6471 3.31365C14.3013 3.78415 15.8413 3.4237 16.3228 4.0761C16.8043 4.7285 15.9764 6.05015 16.232 6.8272C16.4875 7.60424 17.9412 8.16906 17.9412 9H17.94Z"
                    stroke="#2A5A16"
                    strokeWidth="1.2"
                    strokeMiterlimit="10"
                  />
                  <path
                    d="M6.17188 9.377C6.88055 9.96989 7.58922 10.5628 8.2979 11.1557C9.78793 9.71836 11.278 8.28106 12.768 6.84375"
                    stroke="#2A5A16"
                    strokeWidth="1.2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span className="text-[#2a5a16] text-[12px]">
                  Reconnu par l'État
                </span>
              </>
            ) : null}
          </div>
        </div>
        <div className="flex gap-4">
        
          <div
            onClick={handleModel}
          >
            <svg
              width="18"
              height="20"
              viewBox="0 0 18 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.42773 8.45496L11.7853 5.50684"
                stroke="#005073"
                strokeWidth="0.9"
                strokeMiterlimit="10"
              />
              <path
                d="M11.7853 14.5243L6.42773 11.5762"
                stroke="#005073"
                strokeWidth="0.9"
                strokeMiterlimit="10"
              />
              <path
                d="M14.4642 7.09839C16.1483 7.09839 17.5134 5.73322 17.5134 4.04919C17.5134 2.36517 16.1483 1 14.4642 1C12.7802 1 11.415 2.36517 11.415 4.04919C11.415 5.73322 12.7802 7.09839 14.4642 7.09839Z"
                stroke="#005073"
                strokeWidth="0.9"
                strokeMiterlimit="10"
              />
              <path
                d="M14.4642 18.9998C16.1483 18.9998 17.5134 17.6346 17.5134 15.9506C17.5134 14.2665 16.1483 12.9014 14.4642 12.9014C12.7802 12.9014 11.415 14.2665 11.415 15.9506C11.415 17.6346 12.7802 18.9998 14.4642 18.9998Z"
                stroke="#005073"
                strokeWidth="0.9"
                strokeMiterlimit="10"
              />
              <path
                d="M3.79919 13.0496C5.48322 13.0496 6.84839 11.6844 6.84839 10.0004C6.84839 8.31634 5.48322 6.95117 3.79919 6.95117C2.11517 6.95117 0.75 8.31634 0.75 10.0004C0.75 11.6844 2.11517 13.0496 3.79919 13.0496Z"
                stroke="#005073"
                strokeWidth="0.9"
                strokeMiterlimit="10"
              />
            </svg>

          </div>
          <SocialShare
            opened={opened}
            onClosed={onClosed}
            shareLink={`https://dev.aceorientation.com/country/${slugify(
              name
            )}`}
          />
          <div onClick={() => favourites(publicId)}>
            <svg
              width="25"
              height="22"
              viewBox="0 0 25 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M23.9582 4.66959L23.9583 4.66977C24.7525 6.16486 24.6253 7.8178 23.8892 9.53864C23.1499 11.2669 21.8161 13.0097 20.2964 14.6079C17.4061 17.6475 13.9427 20.0629 12.9621 20.7467C12.9127 20.7812 12.8695 20.8113 12.833 20.8368L12.8328 20.837C12.7446 20.8989 12.6527 20.947 12.5582 20.9795L12.5568 20.98C12.5334 20.9881 12.5143 20.9938 12.5 20.9973C12.4857 20.9938 12.4666 20.9881 12.4432 20.98L12.4419 20.9795C12.3465 20.9467 12.2546 20.8988 12.1672 20.8375L12.1669 20.8373C12.1309 20.812 12.0883 20.7823 12.0395 20.7483C11.0612 20.0662 7.59544 17.6497 4.70343 14.6081C3.18378 13.0098 1.85005 11.2669 1.1108 9.53854C0.374713 7.81759 0.247544 6.16452 1.04176 4.6693L1.04179 4.66923C2.24838 2.39688 4.52106 1 6.96181 1C9.09559 1 10.9477 2.04254 12.0788 3.81103L12.5 4.46962L12.9212 3.81103C14.0523 2.04254 15.9044 1 18.0382 1C20.479 1 22.7521 2.39691 23.9582 4.66959Z"
                stroke="#005073"
              />
            </svg>
          </div>
        </div>
      </div>
      <div className="flex bg-[#12cfef1f] p-4 justify-between w-full rounded-lg">
        <div className="flex gap-4">
          <div className="flex flex-col justify-between items-center">
            <svg
              width="26"
              height="26"
              viewBox="0 0 26 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M21.3234 3.01465H1.77737C1.34804 3.01465 1 3.36269 1 3.79201V20.3556C1 20.7849 1.34804 21.133 1.77737 21.133H21.3234C21.7528 21.133 22.1008 20.7849 22.1008 20.3556V3.79201C22.1008 3.36269 21.7528 3.01465 21.3234 3.01465Z"
                stroke="#005073"
                strokeWidth="1.2"
                strokeMiterlimit="10"
              />
              <path
                d="M7.12659 9.28809H4.82766C4.39833 9.28809 4.05029 9.63612 4.05029 10.0655V12.3644C4.05029 12.7937 4.39833 13.1417 4.82766 13.1417H7.12659C7.55591 13.1417 7.90395 12.7937 7.90395 12.3644V10.0655C7.90395 9.63612 7.55591 9.28809 7.12659 9.28809Z"
                stroke="#005073"
                strokeWidth="0.8"
                strokeMiterlimit="10"
              />
              <path
                d="M12.6998 9.28809H10.4009C9.97157 9.28809 9.62354 9.63612 9.62354 10.0655V12.3644C9.62354 12.7937 9.97157 13.1417 10.4009 13.1417H12.6998C13.1292 13.1417 13.4772 12.7937 13.4772 12.3644V10.0655C13.4772 9.63612 13.1292 9.28809 12.6998 9.28809Z"
                stroke="#005073"
                strokeWidth="0.8"
                strokeMiterlimit="10"
              />
              <path
                d="M18.2731 9.28809H15.9741C15.5448 9.28809 15.1968 9.63612 15.1968 10.0655V12.3644C15.1968 12.7937 15.5448 13.1417 15.9741 13.1417H18.2731C18.7024 13.1417 19.0504 12.7937 19.0504 12.3644V10.0655C19.0504 9.63612 18.7024 9.28809 18.2731 9.28809Z"
                stroke="#005073"
                strokeWidth="0.8"
                strokeMiterlimit="10"
              />
              <path
                d="M7.12659 14.5889H4.82766C4.39833 14.5889 4.05029 14.9369 4.05029 15.3662V17.6652C4.05029 18.0945 4.39833 18.4425 4.82766 18.4425H7.12659C7.55591 18.4425 7.90395 18.0945 7.90395 17.6652V15.3662C7.90395 14.9369 7.55591 14.5889 7.12659 14.5889Z"
                stroke="#005073"
                strokeWidth="0.8"
                strokeMiterlimit="10"
              />
              <path
                d="M12.6998 14.5889H10.4009C9.97157 14.5889 9.62354 14.9369 9.62354 15.3662V17.6652C9.62354 18.0945 9.97157 18.4425 10.4009 18.4425H12.6998C13.1292 18.4425 13.4772 18.0945 13.4772 17.6652V15.3662C13.4772 14.9369 13.1292 14.5889 12.6998 14.5889Z"
                stroke="#005073"
                strokeWidth="0.8"
                strokeMiterlimit="10"
              />
              <path
                d="M18.2731 14.5889H15.9741C15.5448 14.5889 15.1968 14.9369 15.1968 15.3662V17.6652C15.1968 18.0945 15.5448 18.4425 15.9741 18.4425H18.2731C18.7024 18.4425 19.0504 18.0945 19.0504 17.6652V15.3662C19.0504 14.9369 18.7024 14.5889 18.2731 14.5889Z"
                stroke="#005073"
                strokeWidth="0.8"
                strokeMiterlimit="10"
              />
              <path
                d="M1 7.34766H22.1008"
                stroke="#005073"
                strokeWidth="0.8"
                strokeMiterlimit="10"
              />
              <path
                d="M6.77187 1H6.19973C5.7704 1 5.42236 1.34804 5.42236 1.77737V5.02675C5.42236 5.45608 5.7704 5.80412 6.19973 5.80412H6.77187C7.2012 5.80412 7.54924 5.45608 7.54924 5.02675V1.77737C7.54924 1.34804 7.2012 1 6.77187 1Z"
                fill="#E3F9FD"
                stroke="#005073"
                strokeWidth="0.8"
                strokeMiterlimit="10"
              />
              <path
                d="M16.9013 1H16.3291C15.8998 1 15.5518 1.34804 15.5518 1.77737V5.02675C15.5518 5.45608 15.8998 5.80412 16.3291 5.80412H16.9013C17.3306 5.80412 17.6786 5.45608 17.6786 5.02675V1.77737C17.6786 1.34804 17.3306 1 16.9013 1Z"
                fill="#E3F9FD"
                stroke="#005073"
                strokeWidth="0.8"
                strokeMiterlimit="10"
              />
              <path
                d="M19.5567 25.0001C22.2903 25.0001 24.5064 22.784 24.5064 20.0503C24.5064 17.3167 22.2903 15.1006 19.5567 15.1006C16.823 15.1006 14.6069 17.3167 14.6069 20.0503C14.6069 22.784 16.823 25.0001 19.5567 25.0001Z"
                fill="#E3F9FD"
                stroke="#005073"
                strokeWidth="1.2"
                strokeMiterlimit="10"
              />
              <path
                d="M19.5322 16.9316V20.0193C20.3884 19.6783 21.2445 19.3373 22.1006 18.9963"
                stroke="#005073"
                strokeWidth="0.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span className="text-[12px] text-[#505050]">
              {annualBackToSchool !== ""
                // ? moment(new Date(annualBackToSchool)).format("DD MMM YYYY")
                ? moment(annualBackToSchool, "DD/MM/YYYY").format("DD MMM YYYY")
                : "Non renseigné"}
            </span>
          </div>
          <div className="flex flex-col justify-between items-center">
            <svg
              width="27"
              height="22"
              viewBox="0 0 27 22"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.13357 1H23.5372C23.9193 1 24.2294 1.31009 24.2294 1.69216V14.2341H5.44141V1.69216C5.44141 1.31009 5.75149 1 6.13357 1Z"
                stroke="#005073"
                strokeWidth="1.2"
                strokeMiterlimit="10"
              />
              <path
                d="M24.8074 14.2812H4.86208C4.47981 14.2812 4.16992 14.5911 4.16992 14.9734V15.457C4.16992 15.8393 4.47981 16.1492 4.86208 16.1492H24.8074C25.1896 16.1492 25.4995 15.8393 25.4995 15.457V14.9734C25.4995 14.5911 25.1896 14.2812 24.8074 14.2812Z"
                stroke="#005073"
                strokeWidth="1.2"
                strokeMiterlimit="10"
              />
              <path
                d="M7.71387 4.23242H22.0319"
                stroke="#005073"
                strokeWidth="0.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M7.63965 6.7998H21.9577"
                stroke="#005073"
                strokeWidth="0.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M7.63965 9.36621H13.6236"
                stroke="#005073"
                strokeWidth="0.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M13.6146 15.2326C13.6744 15.0111 13.5433 14.7832 13.3219 14.7234C13.1004 14.6637 12.8725 14.7947 12.8127 15.0162L12.0808 17.7289C12.021 17.9503 12.1521 18.1783 12.3735 18.238C12.595 18.2978 12.8229 18.1667 12.8827 17.9453L13.6146 15.2326Z"
                fill="#E3F9FD"
                stroke="#005073"
                strokeWidth="0.8"
                strokeMiterlimit="10"
              />
              <path
                d="M6.21304 16.6839C7.64884 16.6839 8.81279 15.5199 8.81279 14.0841C8.81279 12.6483 7.64884 11.4844 6.21304 11.4844C4.77724 11.4844 3.61328 12.6483 3.61328 14.0841C3.61328 15.5199 4.77724 16.6839 6.21304 16.6839Z"
                fill="#E3F9FD"
                stroke="#005073"
                strokeWidth="1.2"
                strokeMiterlimit="10"
              />
              <path
                d="M10.9254 20.9301C10.7879 18.7678 8.73031 17.0508 6.21269 17.0508C3.69507 17.0508 1.63751 18.7673 1.5 20.9301H10.9258H10.9254Z"
                fill="#E3F9FD"
                stroke="#005073"
                strokeWidth="1.2"
                strokeMiterlimit="10"
              />
              <path
                d="M9.64648 20.9306L11.1702 17.9659C11.4812 17.3609 12.2236 17.1223 12.829 17.4334C13.434 17.7444 13.6726 18.4868 13.3615 19.0922L12.4165 20.9306H9.64648Z"
                fill="#E3F9FD"
                stroke="#005073"
                strokeWidth="1.2"
                strokeMiterlimit="10"
              />
            </svg>
            <span className=" text-[12px] text-[#505050]">
              {teachingMode !== null && teachingMode.length > 0
                ? (teachingMode)
                : "Non renseigné"}
            </span>
          </div>
          <div className="flex flex-col justify-between items-center">
            <svg
              width="24"
              height="26"
              viewBox="0 0 24 26"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M17.782 2.13672C17.5708 2.34788 17.171 2.68713 17.0284 2.80718C16.9931 2.83719 16.9593 2.86881 16.9245 2.8999C16.5809 3.20699 16.0659 3.34044 15.6066 3.35223L15.3172 3.35973C15.0047 3.36777 14.7175 3.53338 14.5545 3.80081C14.3428 4.1481 14.3841 4.59239 14.6553 4.89466L14.8027 5.05866C15.0042 5.28322 15.3032 5.39469 15.6023 5.35664C15.8729 5.32234 16.2224 5.27786 16.5557 5.23552C17.0118 5.17764 17.4749 5.21194 17.9176 5.33628C18.3109 5.44722 18.7048 5.55762 19.0982 5.66856C19.4916 5.7795 19.9241 5.75217 20.3057 5.58763C20.5855 5.46651 20.7725 5.35986 21.0957 4.99328"
                stroke="#005073"
                strokeWidth="0.8"
                strokeMiterlimit="10"
              />
              <path
                d="M8.95024 1.86621C9.47117 2.13632 9.62927 2.7489 10.4578 3.07315C10.9 3.24626 11.1712 3.22482 11.475 3.20928C11.922 3.18677 12.3352 3.47671 12.4322 3.91404C12.436 3.93226 12.4397 3.95048 12.443 3.96924C12.5416 4.5786 12.0689 5.28068 11.2467 5.55133C10.7724 5.65155 9.96209 6.05458 9.20159 6.76202C9.18123 6.78078 9.1614 6.80168 9.14157 6.82472C8.62814 7.41318 7.82208 7.6356 7.06212 7.45713C6.95601 7.43194 6.84989 7.41854 6.74377 7.42176C6.71055 7.42283 6.67732 7.42605 6.64409 7.43087C6.16657 7.50161 5.83965 7.9502 5.91897 8.42665L5.92432 8.4588C5.96023 8.67371 6.07546 8.86719 6.24803 9.00064C6.3654 9.09121 6.48224 9.18179 6.59961 9.27236C6.90777 9.51085 7.05194 9.90477 6.96887 10.2847C6.93725 10.4289 6.88741 10.5838 6.8097 10.7414C6.71108 10.9413 6.40721 11.5576 5.84501 11.6482C5.13649 11.7623 4.54375 10.84 4.37868 10.587C4.08605 10.1384 3.99387 9.72952 3.85774 9.10139C3.75752 8.63888 3.66105 8.02415 3.64551 7.28777"
                stroke="#005073"
                strokeWidth="0.8"
                strokeMiterlimit="10"
              />
              <path
                d="M8.34471 11.0566L7.20584 12.7266C7.11366 12.8622 7.08793 13.0321 7.13616 13.1891L7.45291 14.2181C7.49739 14.3633 7.60136 14.4829 7.7391 14.5477L8.49048 14.9009C8.67753 14.9888 8.79811 15.1758 8.80026 15.3827L8.83241 18.0142C8.83402 18.1514 8.88815 18.2832 8.98355 18.3818L9.05429 18.4552C9.23008 18.638 9.50984 18.6728 9.72582 18.5399L10.0544 18.3373C10.1867 18.2553 10.2773 18.1208 10.303 17.967L10.3614 17.6154C10.3845 17.4761 10.4617 17.3512 10.5758 17.2681L11.3299 16.7188C11.4607 16.6234 11.5416 16.4749 11.5507 16.3136L11.6059 15.3468C11.6107 15.2621 11.6354 15.1796 11.6783 15.1061L12.6344 13.4624C12.6858 13.374 12.711 13.2727 12.7073 13.1703C12.6992 12.9597 12.5695 12.7737 12.375 12.6928L12.0572 12.561C11.9569 12.5192 11.8712 12.4484 11.8117 12.3573L10.9805 11.0807C10.8818 10.929 10.7136 10.8374 10.5329 10.8358L8.7949 10.8213C8.61482 10.8197 8.446 10.9081 8.34471 11.0566Z"
                stroke="#005073"
                strokeWidth="0.8"
                strokeMiterlimit="10"
              />
              <path
                d="M20.3718 18.6261C20.114 18.5376 19.7115 18.3527 19.4457 17.9572C19.2871 17.7214 19.189 17.4282 19.1885 16.3108C19.1885 15.8751 19.2029 15.2866 19.2656 14.5872C19.2195 14.3814 19.1247 14.0974 18.9055 13.8412C18.5014 13.3685 18.1107 13.5003 17.7993 13.0952C17.4595 12.6536 17.7993 12.3341 17.4391 11.7575C17.1321 11.2655 16.6218 11.0774 16.513 11.0372C16.0923 10.8823 15.9358 11.0007 15.5098 10.9343C14.8414 10.8298 14.0563 10.3544 13.7605 9.59656C13.7197 9.49205 13.4083 8.69618 13.8376 8.10451C14.2551 7.52891 15.1544 7.45066 15.7156 7.66718C16.0071 7.77973 16.0344 7.90567 16.796 8.33603C17.1144 8.51611 17.2735 8.60615 17.4391 8.67046C17.5463 8.71226 18.2886 8.99041 19.1113 8.79908C19.666 8.66992 19.8166 8.42982 20.5004 8.00161C20.9104 7.74489 21.5385 7.40403 22.4041 7.12695"
                stroke="#005073"
                strokeWidth="0.8"
                strokeMiterlimit="10"
              />
              <path
                d="M13.0877 21.5876C18.7728 21.5876 23.3815 16.9789 23.3815 11.2938C23.3815 5.60869 18.7728 1 13.0877 1C7.40263 1 2.79395 5.60869 2.79395 11.2938C2.79395 16.9789 7.40263 21.5876 13.0877 21.5876Z"
                stroke="#005073"
                strokeWidth="1.2"
                strokeMiterlimit="10"
              />
              <path
                d="M11.4637 23.2439H8.83544L6.6338 24.9996L4.43216 23.2439H1.80391C1.36015 23.2439 1 22.8837 1 22.44V16.3303C1 15.8865 1.36015 15.5264 1.80391 15.5264H11.4637C11.9074 15.5264 12.2676 15.8865 12.2676 16.3303V22.44C12.2676 22.8837 11.9074 23.2439 11.4637 23.2439Z"
                fill="#E3F9FD"
                stroke="#005073"
                strokeWidth="1.2"
                strokeLinejoin="round"
              />
              <path
                d="M3.00781 17.7002H10.5195"
                stroke="#005073"
                strokeWidth="0.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M2.96875 19.4365H10.4805"
                stroke="#005073"
                strokeWidth="0.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M2.96875 21.1729H6.6335"
                stroke="#005073"
                strokeWidth="0.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span className="text-[12px] text-[#505050]">

              {language !== null && language.length > 0
                ? (language)
                : "Non renseigné"}
            </span>
          </div>
        </div>
        <Link
          to={{
            pathname: `/etablissements/${slugify(name)}`,
            state: { code: publicId, isPublic: isPublic, name: name },
          }}
          className="px-[13px] py-[10px] text-[12px] text-white bg-[#005073] rounded-full flex self-end items-center gap-2"
        >
          <span>Lire Plus</span>
          <svg
            width="16"
            height="12"
            viewBox="0 0 16 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M0.953125 6H13.9335"
              stroke="white"
              strokeWidth="1.68421"
              strokeMiterlimit="10"
              strokeLinecap="round"
            />
            <path
              d="M9.84229 0.947266L14.8125 5.9999L9.84229 11.0525"
              stroke="white"
              strokeWidth="1.68421"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Link>
      </div>
    </div>
  </>
);
